// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"80edd4a0","781":"4e09f101","787":"c3525396"}[chunkId] + ".chunk.js";
};